<interacta-live-status
    [message]="
        newUnreadCount() === null
            ? null
            : ('SHARED.NOTIFICATIONS.UNREAD_COUNT'
              | translate: { count: newUnreadCount() })
    "
/>

<button
    aria-haspopup="dialog"
    data-testid="notifications-trigger"
    interacta-icon-button
    type="button"
    [attr.aria-description]="
        unreadNotificationsCount() > 0
            ? ('SHARED.NOTIFICATIONS.UNREAD_COUNT'
              | translate: { count: unreadNotificationsCount() })
            : null
    "
    [attr.aria-expanded]="isPanelOpen()"
    [disabled]="
        notifications().nextPageToken.tag === 'firstLoading' &&
        !notifications().isFetching
    "
    [icon]="unreadNotificationsCount() > 0 ? 'bell-dot' : 'bell'"
    [label]="'SHARED.NOTIFICATIONS.OPEN' | translate"
    [ngClass]="{
        'text-text-primary': unreadNotificationsCount() > 0,
        'text-text': unreadNotificationsCount() === 0,
        'hover:animate-swing': unreadNotificationsCount(),
        'animate-swing': unreadNotificationsCount() && newNotificationToggle(),
    }"
    [size]="'regular'"
    [style]="'text'"
    (click)="openNotificationPanel()"
></button>
